import { FC } from 'react';
import {
  generatePath,
  useParams,
  useRouteMatch,
  useHistory,
} from 'react-router-dom';
import cookie from 'js-cookie';
import { Flex } from '@rebass/emotion';
import useMenuConfig from '@app/hooks/useMenuConfig';
import { MenuConfigHookOut } from '@app/hooks/useMenuConfig/types';
import useContentPage from '@app/hooks/useContentPage';
import Loader from '@app/components/Loader';
import theme from '@app/styles/theme';
import ProductFinder from './ProductFinder';
import { generateQueryString, FinderState } from './url';
import RouteProps from '../RoutesWithLayout/RouteProps';

const MENU_VARIANT_COOKIE = 'product_finder_menu_variant';

export const ProductFinderPage: FC<RouteProps> = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  const params = useParams<{ language: string; url: string }>();

  const { loading: menuConfigLoading, ...menuConfig } = useMenuConfig(
    cookie.get(MENU_VARIANT_COOKIE)
  );

  const contentPage = useContentPage(menuConfig?.menuSlugs);

  if (menuConfigLoading) {
    return (
      <Flex py={4} justifyContent="center">
        <Loader color={theme.colors.lighterBlue} size={30} />
      </Flex>
    );
  }

  const getPathFromSearchState = (newSearchState: FinderState): string =>
    decodeURIComponent(
      generatePath(path, {
        language: params.language,
        url: `${params.url || ''}${generateQueryString(
          menuConfig?.filters,
          newSearchState
        )}`,
      })
    );

  const updateUrl = (newSearchState: FinderState): void => {
    history.push(getPathFromSearchState(newSearchState));
  };

  return (
    <ProductFinder
      onSearch={updateUrl}
      {...(menuConfig as Omit<MenuConfigHookOut, 'loading'>)}
      {...contentPage}
    />
  );
};

export default ProductFinderPage;
